import { createSvgIcon } from "@mui/material";

const FundOperationsIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M0 12.1905C0 5.45786 5.73076 0 12.8 0H35.2C42.2692 0 48 5.45786 48 12.1905V35.8095C48 42.5421 42.2692 48 35.2 48H12.8C5.73075 48 0 42.5421 0 35.8095V12.1905Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      opacity="0.81"
      d="M36.8877 6.50854H21.1473C18.2018 6.50854 15.814 8.89636 15.814 11.8419V27.5823H31.5544C34.4999 27.5823 36.8877 25.1945 36.8877 22.2489V6.50854Z"
      fill="#C7F8E5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5073 35.7409C15.2474 35.7409 14.2334 34.7253 14.2334 33.4817C14.2334 32.2381 15.2474 31.2226 16.5073 31.2226H31.0009C33.2837 31.2226 35.1343 29.372 35.1343 27.0893V24.818C35.1343 24.3025 34.7164 23.8846 34.2009 23.8846C33.6855 23.8846 33.2676 24.3025 33.2676 24.818V27.0893C33.2676 28.3411 32.2528 29.3559 31.0009 29.3559H16.5073C15.6682 29.3559 14.8865 29.605 14.2334 30.0334V14.7525C14.2334 13.5007 15.2482 12.4859 16.5 12.4859H24.5868C25.1023 12.4859 25.5201 12.068 25.5201 11.5525C25.5201 11.0371 25.1023 10.6192 24.5868 10.6192H16.5C14.2173 10.6192 12.3667 12.4698 12.3667 14.7525V33.4817C12.3667 35.7644 14.2246 37.6075 16.5073 37.6075H31.5307C33.5189 37.6075 35.1307 35.9958 35.1307 34.0075V33.4817C35.1307 32.9663 34.7128 32.5484 34.1973 32.5484C33.6819 32.5484 33.264 32.9663 33.264 33.4817V34.0075C33.264 34.9648 32.488 35.7409 31.5307 35.7409H16.5073Z"
      fill="#20B279"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7124 18.1091C17.7124 17.5936 18.1303 17.1758 18.6457 17.1758H21.7552C22.2707 17.1758 22.6885 17.5936 22.6885 18.1091C22.6885 18.6246 22.2707 19.0424 21.7552 19.0424H18.6457C18.1303 19.0424 17.7124 18.6246 17.7124 18.1091Z"
      fill="#20B279"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7124 23.3688C17.7124 22.8533 18.1303 22.4354 18.6457 22.4354H24.858C25.3734 22.4354 25.7913 22.8533 25.7913 23.3688C25.7913 23.8842 25.3734 24.3021 24.858 24.3021H18.6457C18.1303 24.3021 17.7124 23.8842 17.7124 23.3688Z"
      fill="#20B279"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.9571 11.1196C27.1195 10.8162 27.4358 10.6267 27.78 10.6267H34.851C35.3665 10.6267 35.7844 11.0446 35.7844 11.56V12.9742C35.7844 13.4897 35.3665 13.9076 34.851 13.9076C34.3356 13.9076 33.9177 13.4897 33.9177 12.9742V12.4934H29.524L31.385 15.2849C31.594 15.5984 31.594 16.0069 31.385 16.3204L29.524 19.1119H33.9177V18.631C33.9177 18.1156 34.3356 17.6977 34.851 17.6977C35.3665 17.6977 35.7844 18.1156 35.7844 18.631V20.0452C35.7844 20.5607 35.3665 20.9786 34.851 20.9786H27.78C27.4358 20.9786 27.1195 20.7891 26.9571 20.4857C26.7947 20.1822 26.8125 19.8139 27.0034 19.5275L29.4867 15.8026L27.0034 12.0778C26.8125 11.7914 26.7947 11.4231 26.9571 11.1196Z"
      fill="#20B279"
    />
  </svg>,
  "FundOperationsIcon"
);

export default FundOperationsIcon;
